import { getString } from "./dateutil";

export default function log(s: string) {
  console.log(`[${getString(new Date())}] ${s}`)
}
